import { useForm } from 'react-hook-form';

import { type ProfileEditFormValues } from '../types';

import { useProfileDataQuery } from './use-profile-data-query';

export const useProfileEditForm = () => {
  const { data } = useProfileDataQuery();

  const formMethods = useForm<ProfileEditFormValues>({
    mode: 'onBlur',
    defaultValues: {
      nickname: data?.name,
      about: data?.about,
    },
  });

  return { formMethods };
};
